import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsBed({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M4.4 8c1.1 0 2-.93 2-2.08s-.9-2.09-2-2.09-2 .94-2 2.09S3.3 8 4.4 8zm8.8-3.33H7.6a.4.4 0 00-.4.41v3.75H1.6V3.42A.4.4 0 001.2 3H.4a.4.4 0 00-.4.42v9.16c0 .23.18.42.4.42h.8a.4.4 0 00.4-.42v-1.25h12.8v1.25c0 .23.18.42.4.42h.8a.4.4 0 00.4-.42v-5a2.86 2.86 0 00-2.8-2.91z" />
    </svg>
  );
}

SvgSettingsBed.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsBed.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgSettingsBed svgRef={ref} {...props} />);
export default ForwardRef;
